<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">รายงานการจำหน่ายน้ำมันของเรือขนย้ายน้ำมัน</h2>
        </div>
        <!-- <h5 class="mx-5 mt-2">ปลายทาง : {{ selectedDestinationType.name }}</h5> -->
      </div>
    </div>
    <vx-card>
      <div class="vx-row my-0">
        <div class="vx-col md:w-1/5 w-full">
          <form autocomplete="off" class="w-full">
            <vs-select
              id="searchVesselName"
              class="w-full select-large"
              label="ชื่อเรือขนย้ายน้ำมัน"
              v-model="selectedForwardTanker"
              placeholder="กรุณาเลือกเรือขนย้ายน้ำมัน"
              autocomplete
            >
              <vs-select-item :value="null" text="กรุณาเลือกเรือขนย้ายน้ำมัน" />
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.name"
                v-for="(item, index) in optionsTanker"
                class="w-full"
              />
            </vs-select>
          </form>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <form autocomplete="off" class="w-full">
            <vs-select
              class="w-full select-large"
              label="โรงกลั่น"
              v-model="selectedRefinery"
              autocomplete
              :placeholder="selectedRefinery.name"
            >
              <vs-select-item :value="null" text="ทั้งหมด" />
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.label"
                v-for="(item, index) in optionsRefinery"
                class="w-full"
              />
            </vs-select>
          </form>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <form autocomplete="off" class="w-full">
            <vs-select
              id="searchVesselName"
              class="w-full select-large"
              label="ชื่อเรือสถานีบริการน้ำมัน"
              v-model="selectedTanker"
              autocomplete
            >
              <vs-select-item :value="null" text="ทั้งหมด" />
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.name"
                v-for="(item, index) in optionsTanker"
                class="w-full"
              />
            </vs-select>
          </form>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <v-date-picker
            v-model="selectedDate"
            mode="date"
            is-range
            is24hr
            :locale="$i18n.locale"
            :buddhist="true"
            :max-date="maxDate"
          >
            <template v-slot="{ inputEvents }">
              <vs-input
                v-on="inputEvents.start"
                label="วัน/เดือน/ปี"
                :value="
                  selectedDate.start &&
                  `${
                    selectedDate.start
                      ? setDateFormatTh(selectedDate.start)
                      : ''
                  } - ${
                    selectedDate.end ? setDateFormatTh(selectedDate.end) : ''
                  }`
                "
                class="w-full"
                placeholder="วัน/เดือน/ปี - วัน/เดือน/ปี"
              />
            </template>
          </v-date-picker>
        </div>
        <div class="vx-col md:w-1/5 w-full mt-6 text-center flex">
          <div>
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
              @click="getOilTransfers()"
              >ค้นหา</vs-button
            >
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card class="mt-5 z-0">
      <div class="px-5 pb-5 relative">
        <div class="flex justify-between">
          <div class="flex">
            <div class="mt-5">
              <vs-chip color="#BADDC2" class="text-center">
                <p style="color: #000" class="m-2">
                  รับน้ำมัน
                  {{
                    countRefinery ? formatNumber(countRefinery) : 0
                  }}
                  ครั้ง<br />
                  ยอดรับ {{ receive ? formatNumber(receive) : 0 }} ลิตร
                </p>
              </vs-chip>
              <vs-chip color="#F7CAC8" class="text-center">
                <p style="color: #000" class="m-2">
                  จ่ายน้ำมัน
                  {{ countTanker ? formatNumber(countTanker) : 0 }} ครั้ง<br />
                  ยอดจ่าย {{ prorate ? formatNumber(prorate) : 0 }} ลิตร
                </p>
              </vs-chip>
            </div>
          </div>
          <div>
            <vs-button
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-printer"
              @click="print()"
            >
              พิมพ์
            </vs-button>
          </div>
        </div>
        <vs-table
          maxHeight="460px"
          class="static text-center mt-3"
          :max-items="descriptionItems[0]"
          description
          :description-items="descriptionItems"
          description-title="ลำดับ"
          description-connector="จาก"
          description-body="จำนวนต่อหน้า"
          pagination
          :data="transfers"
        >
          <!-- <template slot="header">
            <div class="px-5 pb-5 flex">
              
            </div>
          </template> -->
          <template slot="thead">
            <vs-th><p class="mx-auto text-center">ลำดับ</p></vs-th>
            <vs-th sort-key="start_at">
              <p class="mx-auto text-center">วัน เดือน ปี / เวลา</p>
            </vs-th>
            <vs-th><p class="mx-auto text-center">โรงกลั่น</p></vs-th>
            <vs-th><p class="mx-auto text-center">เรือบรรทุกน้ำมัน</p></vs-th>
            <vs-th
              ><p class="mx-auto text-center">เรือสถานีบริการน้ำมัน</p></vs-th
            >
            <vs-th
              ><p class="mx-auto text-center">
                ความจุถังน้ำมันเรือสถานีบริการน้ำมัน
              </p></vs-th
            >
            <vs-th><p class="mx-auto text-center">ตำแหน่ง(Lat,Lon)</p></vs-th>
            <vs-th sort-key="volume"
              ><p class="mx-auto text-center">ปริมาณน้ำมัน (ล.)</p></vs-th
            >
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ tr.index + 1 }}
              </vs-td>

              <vs-td :data="data[indextr].start_at">
                {{ data[indextr].start_at }}
              </vs-td>

              <vs-td
                :data="data[indextr].station && data[indextr].station.name"
              >
                <!-- <a href="#" @click="activeRefinary(data[indextr].station)" > -->
                {{ data[indextr].station && data[indextr].station.name }}
                <!-- </a> -->
              </vs-td>

              <vs-td
                :data="
                  data[indextr].forwardTanker &&
                  data[indextr].forwardTanker.name
                "
              >
                <a href="#" @click="tankerInfo(data[indextr].forwardTanker)">
                  {{
                    data[indextr].forwardTanker &&
                    data[indextr].forwardTanker.name
                  }}
                </a>
              </vs-td>

              <vs-td :data="data[indextr].tanker && data[indextr].tanker.name">
                <a href="#" @click="tankerInfo(data[indextr].tanker)">
                  {{ data[indextr].tanker && data[indextr].tanker.name }}
                </a>
              </vs-td>

              <vs-td
                :data="data[indextr].tanker && data[indextr].tanker.capacity"
              >
                {{
                  data[indextr].tanker &&
                  getVolume(data[indextr].tanker.capacity)
                }}
              </vs-td>

              <vs-td :data="data[indextr]">
                <a href="#" @click="isActiveNotification(data[indextr])"
                  >{{ data[indextr].latitude }} ,
                  {{ data[indextr].longitude }}</a
                >
              </vs-td>

              <vs-td
                :data="data[indextr].volume"
                v-if="data[indextr].station && !data[indextr].tanker"
              >
                {{ getVolume(data[indextr].volume) }}
              </vs-td>
              <vs-td
                :data="data[indextr].volume"
                v-else-if="data[indextr].forwardTanker && data[indextr].tanker"
              >
                <p
                  :style="
                    checkCapacityAndVolume(
                      data[indextr].tanker.capacity,
                      data[indextr].volume
                    )
                      ? 'color: red'
                      : 'color: green'
                  "
                >
                  {{ getVolume(data[indextr].volume) }}
                </p>
              </vs-td>
              <vs-td
                :data="data[indextr].volume"
                v-else-if="data[indextr].tanker && data[indextr].vessel"
              >
                <p
                  :style="
                    checkCapacityAndVolume(
                      data[indextr].vessel.capacity,
                      data[indextr].volume
                    )
                      ? 'color: red'
                      : 'color: green'
                  "
                >
                  {{ getVolume(data[indextr].volume) }}
                </p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <vs-prompt
      v-if="tanker"
      color="primary"
      :active.sync="isActiveTankerInfo"
      :buttons-hidden="true"
      :title="`${tanker.name} : ${tanker.mmsi} `"
    >
      <div class="con-exemple-prompt pb-3">
        <p>ชื่อ : {{ tanker.name }}</p>
        <p>ชื่อภาษาอังกฤษ : {{ tanker.name_en }}</p>
        <p>MMSI : {{ tanker.mmsi }}</p>
        <p>IMO : {{ tanker.imo ? tanker.imo : null }}</p>
        <p>รหัสสมาชิก : {{ tanker.member_code }}</p>
        <p>
          ความจุถัง : {{ tanker.capacity ? formatNumber(tanker.capacity) : 0 }}
        </p>
        <p>
          ประเภทเรือ :
          {{
            tanker.type == "tanker" ? "สถานีบริการน้ำมัน" : "เรือบรรทุกน้ำมัน"
          }}
        </p>

        <div v-if="tanker.owner">
          <vs-divider border-style="dashed" position="left"
            ><b>ข้อมูลเจ้าของเรือ</b></vs-divider
          >
          <p>
            ชื่อ :
            {{
              tanker.owner.personType == "นิติบุคคล"
                ? tanker.owner.certificateOperateName
                : `${tanker.owner.title}${tanker.owner.firstName} ${tanker.owner.lastName}`
            }}
          </p>
          <p>
            โทรศัพท์ :
            {{
              tanker.owner.personType == "นิติบุคคล"
                ? tanker.owner.certificatePhoneNumber
                : tanker.owner.phoneNumber
            }}
          </p>

          <p>ประเภทบุคคล : {{ tanker.owner.personType }}</p>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Swal from "sweetalert2";
import { mapState } from "vuex";
import moment from "moment";
import _ from "lodash";
import vSelect from "vue-select";
import { formatNumber } from "@/utils/index";
import downloadExcel from "vue-json-excel";
import DirectTree from "@/components/charts/DirectedTreeOilTransfer.vue";
import Map from "@/components/map/Map.vue";
import CardOilValue from "@/components/statistics-cards/CardOilValue.vue";

export default {
  name: "RefineryOilTransferDashboard",
  components: {
    vSelect,
    Datepicker,
    downloadExcel,
    DirectTree,
    Map,
    CardOilValue,
  },
  data() {
    return {
      formatNumber,
      config: {
        startDate: moment().format("DD/MM/YYYY"),
        endDate: moment().format("DD/MM/YYYY"),
        station: "",
        forwardTanker: "",
        tanker: "",
        vessel: "",
      },
      destinationType: "transit",
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },

      optionsRefinery: [],
      optionsDestinationType: [],
      optionsTanker: [],
      optionsVessel: [],

      selectedRefinery: "",
      selectedForwardTanker: "",
      selectedTanker: "",
      selectedVessel: "",
      maxDate: new Date(),

      descriptionItems: [10, 25, 50, 100],
      jsonFieldsTransit: {
        ลำดับ: {
          field: "index",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        วันที่เริ่ม: "departed_at_formatted_be",
        ชื่อโรงกลั่น: "station.code",
        MMSI: "vessel.mmsi",
        ชื่อเรือบรรทุกน้ำมัน: "vessel.name",
        "ปริมาณน้ำมัน (ลิตร)": "volumes",
      },
      jsonFieldsDomisticExport: {
        ลำดับ: {
          field: "index",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        วันที่เริ่ม: "departed_at_formatted_be",
        ชื่อโรงกลั่น: "station.code",
        ชื่อเรือบรรทุกน้ำมัน: "vessel.name",
        ประเภทน้ำมัน: "oil_type",
        "ปริมาณน้ำมัน (ลิตร)": "volume",
        "ปริมาณน้ำมันรวม (ลิตร)": {
          field: "volumes",
          callback: (value) => {
            return `${this.getVolume(value)}`;
          },
        },
      },

      oilTransfers: [],
      isActiveRefinary: false,
      selectedStation: null,
      totalOilVolume: 0,
      isCheckCapacityAndVolume: null,
      receive: 0,
      prorate: 0,
      isActiveTankerInfo: false,
      isActiveVesselInfo: false,
      tanker: null,
      vessel: null,
      countTanker: null,
      countRefinery: null,
    };
  },
  computed: {
    ...mapState({
      vesselInFisferies: (state) => state.vessels.vessels,
      vesselInPetrol: (state) => state.petrol.vessels,
      transfers: (state) => state.oilTransfer.oilTransfers,
      tankerOilTransferForPrint: (state) =>
        state.oilTransfer.tankerOilTransferForPrint,
    }),
  },
  async mounted() {
    await this.$store.dispatch("rts/setPositionEventNotification", null);
    this.getRefinaries();
    this.getTankers();
    this.getVessels();
    // this.getOilTransfers();
  },
  watch: {
    async transfers(newVal, oldVal) {
      // console.log(newVal, oldVal);
      for (let i = 0; i < newVal.length; i++) {
        this.transfers[i].index = i;
      }
      // if (newVal) {
      //   await this.setData(newVal)
      //   await this.getOilVolume()
      // }
    },
    // oilTransfers(newVal, oldVal){
    //   for (let i = 0; i < newVal.length; i++) {
    //     this.oilTransfers[i].index = i;
    //   }
    // }
  },
  methods: {
    async getOilTransfers() {
      this.isActiveRefinary = false;
      if (this.selectedForwardTanker) {
      this.$vs.loading();
        this.config = {
          startDate: this.setDateFormat(this.selectedDate.start),
          endDate: this.setDateFormat(this.selectedDate.end),
          station: this.selectedRefinery && this.selectedRefinery.id,
          forwardTanker:
            this.selectedForwardTanker && this.selectedForwardTanker.id,
          tanker: this.selectedTanker && this.selectedTanker.id,
        }

        console.log("this.config ===> ", this.config);
        localStorage.setItem('searchOilTransfer', JSON.stringify(this.config))
        await this.$store.dispatch(
          "oilTransfer/getForwardTankerOilTransfers",
          this.config
        );
        await this.getOilVolume();
        this.$vs.loading.close();
      } else {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกเรือขนย้ายน้ำมัน",
          text: "สำหรับการค้นหาข้อมูลการรับ-จ่ายน้ำมันของเรือขนย้ายน้ำมัน",
          showConfirmButton: false,
          timer: 2000,
        });
      }
      console.log("this.transfers ", this.transfers);
    },
    async getRefinaries() {
      await this.$store.dispatch("mpTankerData/getMpStations");
      const stations = this.$store.state.mpTankerData.mpStations;
      _.map(stations, (station) => {
        this.optionsRefinery.push({ id: station.id, label: station.name_en });
      });
    },
    async getTankers() {
      await this.$store.dispatch("mpTankerData/getMpTankerAll");
      const tankers = this.$store.state.mpTankerData.mpTankerAll;
      // _.map(tankers, (tanker) => {
      //   this.optionsTanker.push({ id: tanker.id, label: tanker.name, mmsi: tanker.mmsi })
      // })
      this.optionsTanker = tankers;
    },
    async getVessels() {
      await this.$store.dispatch("mpTankerData/getMpVesselAll");
      const vessels = this.$store.state.mpTankerData.mpVesselAll;
      // console.log("vessels >>> ", vessels.length);
      _.map(vessels, (vessel) => {
        this.optionsVessel.push({
          id: vessel.id,
          label: vessel.name,
          registerNumber: vessel.register_number,
        });
      });
    },
    setDateFormat(date) {
      return date ? moment(date).format("DD/MM/YYYY") : null;
    },
    setDateFormatTh(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date).add(543, "years").format("DD/MM/YYYY");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
    getVolume(data) {
      return formatNumber(Number(data));
    },
    async activeRefinary(refinary) {
      this.selectedStation = refinary;
      this.selectedStation.type = "station";

      this.config.station = refinary.id;
      this.config.forwardTanker = null;
      this.config.tanker = null;

      await this.$store.dispatch("oilTransfer/getOilTransfers", this.config);
      // console.log("this.transfers>>>> ", this.transfers);
      // await this.setData(this.transfers)
      this.isActiveRefinary = true;
    },
    async setData(data) {
      this.$vs.loading();
      this.oilTransfers = [];
      for (const a of data) {
        a.station_id &&
          (await this.$store.dispatch(
            "mpTankerData/getMpStationById",
            a.station_id
          ));
        a.forward_tanker_id &&
          (await this.$store.dispatch(
            "mpTankerData/getMpForWardTankerById",
            a.forward_tanker_id
          ));
        a.tanker_id &&
          (await this.$store.dispatch(
            "mpTankerData/getMpTankerById",
            a.tanker_id
          ));
        a.vessel_id &&
          (await this.$store.dispatch(
            "mpTankerData/getMpVesselById",
            a.vessel_id
          ));

        const station = this.$store.state.mpTankerData.mpStation;
        const forwardTanker = this.$store.state.mpTankerData.mpForWardTanker;
        const tanker = this.$store.state.mpTankerData.mpTanker;
        const vessel = this.$store.state.mpTankerData.mpVessel;

        const dataTransfer = {
          ...a,
          station: a.station_id && station,
          forwardTanker: a.forward_tanker_id && forwardTanker,
          tanker: a.tanker_id && tanker,
          vessel: a.vessel_id && vessel,
        };

        this.oilTransfers.push(dataTransfer);
      }
      await this.$store.dispatch(
        "oilTransfer/setTankerOilTransferForPrint",
        this.oilTransfers
      );

      this.$vs.loading.close();
    },
    getOilVolume() {
      if (this.config.forwardTanker) {
        this.totalOilVolume = _.sumBy(this.transfers, (o) => {
          if (o.tanker) {
            return o.volume;
          }
        });
      } else if (this.config.tanker) {
        this.totalOilVolume = _.sumBy(this.transfers, (o) => {
          if (o.vessel) {
            return o.volume;
          }
        });
      } else {
        this.totalOilVolume = _.sumBy(this.transfers, "volume");
      }

      if (this.totalOilVolume == undefined) {
        this.totalOilVolume = _.sumBy(this.transfers, "volume");
      }

      this.receive = _.sumBy(this.transfers, (o) => {
        if (o.station) {
          return o.volume;
        } else {
          return 0;
        }
      });
      this.prorate = _.sumBy(this.transfers, (o) => {
        if (o.forwardTanker) {
          return o.volume;
        } else {
          return 0;
        }
      });
      this.countRefinery = _.filter(this.transfers, function (o) {
        return o.station;
      }).length;
      this.countTanker = _.filter(this.transfers, function (o) {
        return o.tanker;
      }).length;

      // console.log("fishing :: ", this.countVessel);
      // console.log("forwardTanker :: ", this.countTanker);
      // console.log("receive :: ", this.receive);
      // console.log("prorate :: ", this.prorate);
    },
    checkCapacityAndVolume(capacity, volume) {
      return Number(volume) >= Number(capacity) ? true : false;
    },
    print() {
      localStorage.setItem("oilTransfersTanker", JSON.stringify(this.transfers));
      window.open(`/admin/oil_transfer/print`, "_blank");
    },
    async isActiveNotification(data) {
      this.$vs.loading();
      data.to_s = data.tanker
        ? `<p>${data.forwardTanker.name} <br/> 
        MMSI: ${data.forwardTanker.mmsi}<br/>
        <b style="color: red">จ่ายน้ำมัน</b>ให้ ${data.tanker.name}<br/>
        ความจุถัง: ${this.getVolume(data.tanker.capacity)} <br/>
        ปริมาณ ${this.getVolume(data.volume)} ลิตร <br/> วันที่ ${
            data.start_at
          }</p>`
        : `<p>${data.forwardTanker.name} <br/> 
        MMSI: ${data.forwardTanker.mmsi}<br/>
        ความจุถัง: ${this.getVolume(data.forwardTanker.capacity)} <br/>
        <b style="color: green">รับน้ำมัน</b>จาก ${data.station.name}<br/>
        ปริมาณ ${this.getVolume(data.volume)} ลิตร <br/> วันที่ ${
            data.start_at
          }</p>`;
      // console.log("isActiveNotification >> ", data.to_s);

      localStorage.setItem(
        "setPositionEventNotification",
        JSON.stringify(data)
      );
      window.open(`/admin/monitoring`, "_blank");
      await this.$store.dispatch("rts/setPositionEventNotification", data);
      this.$vs.loading.close();
      // this.$router.push(`/monitoring`);
    },
    async tankerInfo(data) {
      this.tanker = data;
      if (data.member_code) {
        //หา tanker(mp) by registerNumber(fishries)
        await this.$store.dispatch(`vessels/setVessels`, {
          registerNumber: data.member_code,
        });
      } else if (data.mmsi) {
        //หา tanker(mp) by mmsi(fishries)
        await this.$store.dispatch(`vessels/setVessels`, { mmsi: data.mmsi });
      } else {
        await this.$store.dispatch(`vessels/clearVessels`);
      }
      await this.$store.dispatch(`petrol/getVesselsByMmsi`, {
        mmsi: data.mmsi,
      });

      if (this.vesselInPetrol.length != 0) {
        this.tanker.imo = this.vesselInPetrol[0].imo_number;
      }
      if (this.vesselInFisferies.length != 0) {
        this.tanker.owner = this.vesselInFisferies[0].registration.createdBy;
      }
      this.isActiveTankerInfo = true;
      console.log("tanker ::: ", data.member_code, data.mmsi, this.tanker);
    },
  },
  async beforeDestroy() {
    await this.$store.dispatch("oilTransfer/clearOilTransfers");
  },
};
</script>

<style lang="css" scoped></style>
